export default {
  notInWhiteLit: 'You are not in the whitelist and have no right to use.',
  unknownError: '发生未知错误，请重新尝试',
  aaCheckoutErrors: {
    _default: '初始化订单失败{0}',
    _title: '提交失败',
    _buttonTitle: '确认',
    flightUnavailable:
      '您选择的航班价格已发生变动，请重新搜索获取更新、更优惠价格的航班',
    sessionUnavailable: '您的操作已超时，请重新搜索',
    errorDownStreamServiceCallFailed:
      '您所选择的航班订购失败，请重新搜索以获取更新、更优惠价格的航班',
    notSupported:
      '您所选择的航班订购失败，请重新搜索以获取更新、更优惠价格的航班',
    errorInvalidPassengerDOB:
      '请查检您是否填写了正确的乘客出生日期，请修改后再尝试',
    seatUnavailable: '您所选择的坐位不可用，请修改后再尝试',
    errorDuplicatePassportNumber: '您使用了重复的护照号码，请修改后再尝试',
    baggageUnavailable: '您所选择的行李服务不可用，请修改后再尝试',
    // errorPerformingCheckout:
    //   '请查检您是否填写了正确的旅行文件(身份证或护照信息)，请修改后再尝试',
    errorPerformingCheckout:
      '初始化订单失败{0}，请检查“护照信息”及“出生日期”是否填写正确。',
    invalidNationality: '您的“国籍/地区”选择有误，请确认并修改后再尝试提交',
    errorInsuranceInvalidPaxAge:
      '当前选中的保险不适用其中一位旅客，请取消或者重新选择其他保险后再行尝试',
  },
  aaCheckoutExceptions: {
    'Invalid time value': '请检查日期相关的输入项是否正确',
  },
  aaLoadDataError: {
    _default: {
      title: '抱歉，出现错误！',
      message: '加载下个页面出现故障，请重新搜索航班，十分抱歉！',
    },
    premiumFlatBedError: {
      title: '抱歉，出现错误！',
      message:
        '您选择的航班在加载豪华平躺座椅时出现错误，请重新搜索或选择其他航班继续您的预订！',
    },
    flightUnavailable: {
      title: '抱歉，您选择的航班已不可预订！',
      message: '请重新搜索或选择其他航班继续您的预订！',
    },
    fareUnavailable: {
      title: '抱歉，您所选择航班的座位已售完！',
      message: '请重新搜索或选择其他航班继续您的预订！',
    },
    'Cannot book a flight departing in less than 2 hours and 15 minutes.': {
      title: '抱歉，您选择的航班已不可预订！',
      message: '请重新搜索或选择其他航班继续您的预订！',
    },
  },
};
